<template>
  <div class=" navbar-horizontal-layout ">

    <vs-navbar v-model="activeItem" class="vx-navbar-layout center-element">


      <div slot="title" class="center-element" >
        <vs-navbar-title class="line-h-0 my-1">
          <a href="https://verificamex.com/" >
            <img v-if="logo" :src="logo" width="175" class="center-element"  alt="Verificamex" ref="logo"/>
            <!-- Mientras se sabe qué logo va, se reserva el alto del de Verificamex para que la barra no brinque. -->
            <div v-else class="center-element logo-placeholder"></div>
          </a>
        </vs-navbar-title>
      </div>

    </vs-navbar>
  </div>
</template>

<script>
import Logo from "@/layouts/components/LogoFull.vue";

const DEFAULT_LOGO = require('@/assets/images/logo/logo-full.svg')

// Solo en estas rutas el :uuid es el id de una firma. En /sign-batch es el del lote y en
// /verify el del documento: ahí va directo el logo de Verificamex.
const SIGNATURE_ROUTE = /^\/sign-documents?\//

// Logo por firma: el src ya resuelto o la petición en curso. Cada pantalla del flujo de firma
// monta su propia barra; así, a partir de la segunda, el logo se pinta al instante.
const logoBySignature = new Map()

function loadLogo(store, uuid) {
  if (!logoBySignature.has(uuid)) {
    const request = store.dispatch("document/getDocumentFromSignature", {uuid: uuid})
      .then(document => {
        // El API solo manda la carpeta cuando el documento usa "Mi logo personalizado".
        let container = document.relationships && document.relationships.container;
        let companyLogo = container && container.data && container.data[0] && container.data[0].logo;
        let src = companyLogo ? "data:image/png;base64," + companyLogo : DEFAULT_LOGO
        logoBySignature.set(uuid, src)
        return src
      })
      .catch(() => {
        // No se guarda: la siguiente pantalla lo vuelve a intentar.
        logoBySignature.delete(uuid)
        return DEFAULT_LOGO
      })
    logoBySignature.set(uuid, request)
  }
  return logoBySignature.get(uuid)
}

export default {
  components: {
    Logo,
  },
  data: () => ({
    activeItem: 0,
    logo: null
  }),
  created() {
    let uuid = this.$route.params.uuid
    if (!uuid || !SIGNATURE_ROUTE.test(this.$route.path)) {
      this.logo = DEFAULT_LOGO
      return
    }
    let cached = logoBySignature.get(uuid)
    if (typeof cached === "string") {
      this.logo = cached
      return
    }
    loadLogo(this.$store, uuid).then(src => {
      this.logo = src
    })
  }
}
</script>
<style scoped>
.vs-navbar--btn-responsive{
  display: none;
}
.center-element{
  display: block!important;
  margin: 0 auto!important;
}
.logo-placeholder{
  width: 175px;
  height: 34px;
}
</style>
